// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1v11n","loaderOuter":"PageOverlayLoader_loaderOuter__3nHcq"};